@if (!nextStep) {
<div class="container qai-auth-container  d-flex align-items-center justify-content-center">
    <div class="card p-4 shadow">
        <div class="card-body p-5 pt-2 pb-2">
            <h3 class="card-title my-5 text-center fw-bold" i18n>Recupera la tua password</h3>
            <form [formGroup]="emailForm" (ngSubmit)="sendForgotPasswordEmail()">
                <div class="mb-5">
                    <fa-icon [icon]="faAt" class="qai-login-icon" style="color: lightgrey"></fa-icon>
                    <input type="text" formControlName="email" id="email" name="email"
                        class="form-control qai-form-control" placeholder="Inserisci il tuo indirizzo email">
                    <div class="form-text text-center" id="optHelp" i18n>
                        Riceverai un codice OTP per reimpostare la password.
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center">
                    <app-loading-button [loading]="loading" [disabled]="emailForm.invalid || loading"
                        i18n>Invia</app-loading-button>
                    <div class="text-center pt-2">
                        <button type="button" class="btn btn-link btn-sm" id="resendBtn"
                            [routerLink]="['/auth/login']">Torna al login</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
}
@else if (nextStep === 'OTP_VERIFY') {
<app-otp [email]="emailForm.get('email')?.getRawValue()" [loading]="loading" action="FORGOT_PASSWORD"
    (otpValidated)="nextStep = 'CHANGE_PASSWORD'"></app-otp>
}
@else if (nextStep === 'CHANGE_PASSWORD') {
<app-change-password [forgotPassword]="true" (resetOTP)="nextStep = 'OTP_VERIFY'"></app-change-password>
}